import react, { useCallback, useEffect, useReducer, useMemo } from 'react'
import lockedReducer from '../../../../utils/defaultReducer'
import api from '../../../../api'
import Loading from '../../../Loading'
import { getSession } from '../../../../auth'
import { DialogActions, Dialog, DialogContent, DialogTitle, Button, Divider,
     Select, FormControl, InputLabel, MenuItem } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import LoadingButton from '@mui/lab/LoadingButton';
import useNotification from '../../../Notification'

let fetchedUsers = null // testing new pattern

const OwnerDialog = ({ data, handleClose, reloadParent }) => {

    const [state, setState] = useReducer(lockedReducer, {
        owner: data.owner?.id || 0,
        user_list: [],
        loading: false
    })

    const enterpriseId = useMemo(()=> getSession()?.profile?.enterprise?.id, [])

    const submit = useCallback(async()=>{
        setState({loading: true})
        const res = await api.post(`/api/enterprises/${enterpriseId}/templates/template_ownership/modify/`, {
            owner: state.owner,
            number: data.number,
            name: data.name
        })
        if (res.status === 200){
            setState({loading: false})
            useNotification('Sucesso!', 'Dono alterado com sucesso', 'success')
            handleClose()
            reloadParent()
        } else {
            useNotification('Ops!', `Não foi possível alterar o dono do template: ${res.data.phone_number || 'Erro desconhecido.'}.`, 'danger')
            setState({loading: false})
        }
    }, [state.owner, data])

    useEffect(() => {
        const initialize = async () => {
            setState({ loading: true })
            const res = await api.get(`/api/enterprises/${enterpriseId}/users/get_users_emails/`)
            if (res.status === 200) {
                fetchedUsers = res.data
                setTimeout(()=>{fetchedUsers = null}, 10000)
                setState({ user_list: fetchedUsers })
            } else {
                useNotification('Ops!', 'Não foi possível carregar os usuários.', 'danger')
                handleClose()
            }
            setState({ loading: false })
        }
        if (!fetchedUsers)
            initialize()
        else
            setState({user_list: fetchedUsers})
    }, [])

    return (
        <>
            <Loading loading={state.loading} />
            <Dialog
                open={true}
                fullWidth
                maxWidth='xs'
            >
                <DialogTitle className={'group-flexbox'}>
                    <span>Dono do template</span> <Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={handleClose} ><CloseIcon /></Button>
                </DialogTitle>
                <Divider />
                <DialogContent className='content-dialog-rows'>
                    <FormControl size='small'>
                        <InputLabel id='select-owner-menu'>Dono</InputLabel>
                        <Select
                            label='Dono'
                            labelId='select-owner-menu'
                            value={state.owner}
                            MenuProps={{className:'owner-select-box'}}
                            onChange={({target}) => setState({owner: target.value})}
                        >
                            <MenuItem  value={0}>Corporativo</MenuItem>
                            {state.user_list.map(user => <MenuItem  value={user.id}>{user.first_name} {user.last_name} ({user.username})</MenuItem>)}
                        </Select>
                    </FormControl>
                    
                </DialogContent>
                <DialogActions style={{ padding: "10px 20px 10px 10px" }}>
                    <LoadingButton
                        onClick={submit}
                        color="primary"
                    >
                        Salvar
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default OwnerDialog